<template>
	<div class="content-i">
		<div class="content-box" style="padding-top: 10px;">
			<div class="element-wrapper">
				<h6 class="element-header">{{ t('titleDocumentTypeMapping','titleDocumentTypeMapping') }}</h6>						
				<div class="element-box col-6">
					<div class="element-info">
						<div class="row">
							<div class="col-12 col-sm-6 col-md-8">
								<div class="element-info-with-icon">
									<div class="element-info-icon">
										<span class="os-icon os-icon-edit-1"></span>
									</div>
									<div class="element-info-text">
										<h5 class="element-inner-header">{{ t('headerDocumentTypeMapping','headerDocumentTypeMapping') }}</h5>
										<div class="element-inner-desc">{{ t('documentTypeMappingFormDesc', 'documentTypeMappingFormDesc') }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="table-responsive" v-if="getDocumentTypes.documentTypes">
						<form id="formDocumentTypeMapping" v-on:submit.prevent="updateDocumentTypeMapping">
							<b-table id="logs-table" striped hover bordered class="mt-3" v-if="getDocumentTypes.documentTypes" :items="getDocumentTypes.documentTypes" :fields="fields" :show-empty="rowEmpty">
								<template v-slot:head(docType)="data">
									<span >{{ t(data.label, data.label) }}</span>
								</template>
								<template v-slot:head(userDocType)="data">
									<span >{{ t(data.label, data.label) }}</span>
								</template>
								<template v-slot:cell(docType)="data">
									<span>{{data.item.name}}</span>
								</template>
								<template v-slot:cell(userDocType)="data">
									<select v-model="data.item.user_doc_type" class="form-control">
										<option v-for="userDocType in getDocumentTypes.userDocTypes" :key="userDocType.id" :value="userDocType.id" :selected="data.item.user_doc_type == userDocType.id">{{userDocType.name}}</option>
									</select>
								</template>											
							</b-table>
							<div class="text-right">
								<button class="btn btn-primary" type="submit">{{ t('updateDocumentTypeMappingBtn','updateDocumentTypeMappingBtn') }}</button>
							</div>
							<transition name="fade">
								<ResponseInfo v-if="getResponseInfo.responseName == 'docTypeMapping'" class="pt-3"/>				
							</transition>	
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>		  
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'
import { VclTable } from 'vue-content-loading'

export default {
name: 'documentTypeMappingView',
	components: {
		ResponseInfo,
		ValidationErrors,
		VclTable
	},
	data() {
		return {
			fields: [
				{key: 'docType', label: this.t('docTypeMappingTableLabelDocumentType', 'docTypeMappingTableLabelDocumentType'), thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'userDocType', label: this.t('docTypeMappingTableLabelUserDocType', 'docTypeMappingTableLabelUserDocType'), thClass: 'showhand brand-color', tdClas: 'text-center'}
			],
			rowEmpty: false	
		}
	},
	methods: {
		requestDocumentTypes() {
			this.$store.dispatch('docTypeMappingStore/getDocTypesList')
		},
		updateDocumentTypeMapping() {
			this.$store.dispatch('docTypeMappingStore/updateDocTypesList', {
				documentTypes: this.getDocumentTypes.documentTypes
			})
		}
	},
	computed: {
		...mapGetters(['getResponseInfo', 'getUserLevel', 'getUserDetails']),
		...mapGetters('docTypeMappingStore', ['getDocumentTypes'])
	},
	created() {
		this.requestDocumentTypes()
	}
}
</script>

<style scoped>

  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }

	table >>> tbody, table >>> thead {
    text-align: center;
  }

</style>